// extracted by mini-css-extract-plugin
export var askAiIcon = "_m1-j";
export var category = "_m1-9";
export var categoryHeader = "_m1-e";
export var container = "_m1-0";
export var group = "_m1-a";
export var groupItems = "_m1-f";
export var groupSeparator = "_m1-k";
export var loading = "_m1-1";
export var noResults = "_m1-3";
export var placeholder = "_m1-2";
export var resultContent = "_m1-5";
export var resultIcon = "_m1-c";
export var resultItem = "_m1-g";
export var resultMeta = "_m1-8";
export var resultSubtitle = "_m1-7";
export var resultSuffix = "_m1-i";
export var resultTitle = "_m1-6";
export var resultsList = "_m1-4";
export var searchGroup = "_m1-d";
export var selected = "_m1-h";
export var subgroup = "_m1-b";